import { useEffect, useState } from 'react';
import { getHomeBannerSlides } from '../services/slider';
import type { BannerSlideDisplay } from '../types/slider';
import { heroSlides } from '../pages/website/homeData';

export function useHomeSliders() {
  const [slides, setSlides] = useState<BannerSlideDisplay[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const data = await getHomeBannerSlides();
        if (!cancelled) {
          setSlides(data.length > 0 ? data : heroSlides);
        }
      } catch {
        if (!cancelled) setSlides(heroSlides);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return { slides, loading };
}
